<!--
 * @Author: zhangzhian@linshimuye.com
 * @Date: 2022-09-20 17:21:53
 * @LastEditors: Gyan
 * @LastEditTime: 2024-01-29 11:55:14
 * @FilePath: \dhr_frontend\src\components\DUpLoadFile\uploadFileBtn.vue
 * @Description: 上传按钮
 * @ImportRoute: import UploadFileBtn from '@/components/DUpLoadFile/uploadFileBtn.vue';
-->
<template>
  <div class="upload-file-btn" :class="[`upload-file-btn--${mode}`]">
    <a-upload
      v-if="mode === 'button'"
      :disabled="disabled"
      :multiple="multiple && isSupportMultipleUpload"
      :customRequest="uploadFile"
      :showUploadList="false"
      :file-list="fileList"
      :accept="accept.map((item) => `.${item}`).join(',')"
      :beforeUpload="beforeUpload"
    >
      <slot>
        <a-button type="link" class="upload-btn">点击上传</a-button>
      </slot>
    </a-upload>

    <slot name="desc"></slot>

    <a-upload-dragger
      v-if="mode === 'dragger'"
      :disabled="disabled"
      :multiple="multiple && isSupportMultipleUpload"
      :customRequest="uploadFile"
      :showUploadList="false"
      :file-list="fileList"
      :beforeUpload="beforeUpload"
      :accept="accept.map((item) => `.${item}`).join(',')"
    >
      <slot>
        <p style="padding: 0 10px;">{{ useAutoTips ? autoTips : '拖拽上传' }}</p>
      </slot>
    </a-upload-dragger>

    <slot
      name="file-list"
      v-bind:fileList="{
        fileList,
        previewUploadFile,
        fileDownload,
        removeFile,
      }"
    >
      <ul class="file-list-box">
        <li class="file-list-item" v-for="(file, idx) in fileList" :key="idx">
          <a-icon
            :type="file.status === 'uploading' ? 'loading' : 'paper-clip'"
          />
          <span v-if="file.status === 'uploading' && isUploadAli"
            >{{ file.progress }}%</span
          >
          <span class="file-name" :title="file.name">{{ file.name }}</span>
          <div class="btn-group">
            <span
              v-show="
                judgeFileType(file) && isPreview && file.status === 'done'
              "
              class="btn"
              @click="previewUploadFile(file)"
              >查看</span
            >

            <!-- 通用的查看方法 -->
            <span
              class="btn"
              v-show="useCommonPreview && file.status === 'done'"
              @click="previewCommonFile(file)"
              >查看</span
            >

            <span
              v-show="file.status === 'done' && isDownload"
              class="btn"
              @click="fileDownload(file)"
              >下载</span
            >
            <span
              v-show="file.status === 'done' && isRemove && !disabled"
              class="btn"
              @click="removeFile(file, idx)"
              >删除</span
            >
          </div>
        </li>
      </ul>
    </slot>
  </div>
</template>
<script>
import { uploadByOSS } from "@/utils/oss-file.js";
import {
  previewCommonFile,
  downloadCommonFile,
  getType,
} from "@/utils/helpers";
import debounce from "lodash/debounce";

/**
 * 上传中校验
 */
export const uploadingCheckRule = {
  validator: (rule, value, callback) => {
    if (Array.isArray(value)) {
      if (value.some((item) => !item?.url)) {
        callback(new Error("正在上传中"));
      } else {
        callback();
      }
    } else if (typeof value === "object" && !value?.url) {
      callback(new Error("正在上传中"));
    } else {
      callback();
    }
  },
  trigger: "change",
};

export default {
  name: "upload-file-btn",
  model: { prop: "value", event: "change" },
  components: {},
  props: {
    /**
     * 样式类型
     * params: button, dragger, preview(只展示文件列表)
     */
    mode: {
      type: String,
      default: "button",
    },
    /**
     * 值
     */
    value: {
      type: [Object, Array, String],
      default: () => [],
    },
    /**
     * 文件是否多选
     */
    multiple: {
      type: Boolean,
      default: false,
    },
    /**
     * 传入的value是对象
     */
    singleValue: {
      type: Boolean,
      default: false,
    },
    /**
     * 限制文件大小，单位为M,为0时不校验大小
     */
    size: {
      type: Number,
      default: 20,
    },
    /**
     * limit为0时，上传文件数量不限制
     */
    limit: {
      type: Number,
      default: 0,
    },
    /**
     * 接受的文件类型，为空时不做限制
     */
    accept: {
      type: Array,
      default: () => [],
    },
    /**
     * 是否上传阿里云
     */
    isUploadAli: {
      type: Boolean,
      default: false,
    },
    /**
     * 阿里云上传配置
     */
    aliUploadOption: {
      type: Object,
      default: () => ({}),
    },
    /**
     * 是否上传到钉盘
     */
    isUploadDing: {
      type: Boolean,
      default: false,
    },
    /**
     * 钉盘附件列表，支持sync修饰符
     */
    ddAttachmentList: {
      type: [Object, Array, String],
      default: () => [],
    },
    /**
     * 自定义上传函数
     */
    fileUploadFnc: {
      type: Function,
    },
    /**
     * 自定义上传前校验函数
     * @type {(file: File) => boolean}
     */
    beforeUploadFnc: {
      type: Function,
    },
    /**
     * 自定义预览函数
     */
    previewFnc: {
      type: Function,
    },
    /**
     * 自定义下载函数
     */
    downloadFnc: {
      type: Function,
    },
    /**
     * 是否可以预览
     */
    isPreview: {
      type: Boolean,
      default: false,
    },
    /**
     * 允许预览的类型为传入的 accept
     */
    previewAccept: {
      type: Boolean,
      default: false,
    },
    /**
     * 是否可以下载
     */
    isDownload: {
      type: Boolean,
      default: false,
    },
    /**
     * 是否可以移除
     */
    isRemove: {
      type: Boolean,
      default: true,
    },
    /**
     * 是否禁用
     */
    disabled: {
      type: Boolean,
    },
    /**
     * 是否使用通用的查看方法, 独立于isPreview，由于 isPreview 配置比较复杂，所以提供一个简单的配置
     */
    useCommonPreview: {
      type: Boolean,
      default: false,
    },
    /**
     * 自定义上传到钉盘方法
     */
    ddFileUploadFnc: {
      type: Function,
    },
    /**
     * 是否支持多选文件
     */
    isSupportMultipleUpload: {
      type: Boolean,
      default: true,
    },
    /**
     * 是否自动根据传入的 accept，size 和 limt 生成提示
     */
    useAutoTips: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      imageFileType: ["jpg", "jpeg", "png"],
      wpsFileType: ["doc", "docx", "xls", "xlsx", "ppt", "pptx"],
      fileList: [],
      dingFileList: [],
    };
  },
  computed: {
    previewFileType() {
      if (this.previewAccept) {
        return this.accept;
      }

      return this.imageFileType.concat(this.wpsFileType, ["pdf"]);
    },
    autoTips() {
      let str = []

      if (this.accept) {
        str.push(`支持${this.accept.join(",")}`)
      }

      if (typeof this.size === 'number') {
        str.push(`文件大小不超过${this.size}M`)
      }

      if (this.singleValue) {
        str.push(`仅能上传一个文件`)
      } else if (this.limit > 0) {
        str.push(`最多上传${this.limit}个文件`)
      }
      
      return str.join('，')
    },
  },
  watch: {
    value: {
      handler(nl) {
        if (this.singleValue) {
          if ((!nl || nl.length === 0) && this.fileList.length === 0) {
            return;
          }

          nl = nl ? (Array.isArray(nl) ? nl : [nl]) : [];
        }

        const isNeedFormat = nl && !nl.every((item) => item.status);

        this.fileList =
          nl && nl.length > 0 && isNeedFormat
            ? nl.map((item) => {
                return {
                  ...item,
                  uid: item.uid || item.id,
                  id: item.id,
                  name: item.name,
                  fileUrl: item.fileUrl || item.url,
                  path: item.path,
                  status: item.status || "done",
                };
              })
            : nl || [];
      },
      immediate: true,
    },
    fileList: {
      handler(nl) {
        if (this.singleValue) {
          let newVal = (nl || [])[0]
          this.$emit("change", newVal);
        } else {
          this.$emit("change", nl || []);
        }
      },
      deep: true,
    },
    dingFileList: {
      handler(nl) {
        if (this.singleValue) {
          if (Array.isArray(nl)) {
            this.$emit("update:ddAttachmentList", nl.length ? nl[nl.length - 1] : undefined);
          } else {
            this.$emit("update:ddAttachmentList", nl || undefined);
          }
        } else {
          this.$emit("update:ddAttachmentList", nl || []);
        }
      },
      deep: true,
    },
    ddAttachmentList: {
      handler(nl) {
        if (this.singleValue) {
          if ((!nl || nl.length === 0) && this.dingFileList.length === 0) {
            return;
          }

          nl = nl ? (Array.isArray(nl) ? nl : [nl]) : [];
        } else {
          if (this.dingFileList?.length === 0 && nl?.length === 0) {
            return;
          }
          this.dingFileList = nl;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
  },
  methods: {
    previewCommonFile,
    // oa本地上传
    oaUpload(formData) {
      return this.$axios.post(
        `/${process.env.VUE_APP_PROXY_DING_OA}/attachment/common/upload`,
        formData
      );
    },
    // 阿里云上传
    async aliUpload(file, itemData) {
      const data = await uploadByOSS(file, {
        onProgress: (n) => {
          itemData.progress = n;
        },
        ...this.aliUploadOption,
      });
      return { data };
    },
    // 上传文件到钉盘
    async uploadFileToDingDing(file) {
      let formData = new FormData();
      formData.append("file", file);
      formData.append("employeeNo", this.$store.state?.user?.userInfo?.code);
      // 再上传一份到钉盘
      let { data } = await this.$axios.post(
        `/${process.env.VUE_APP_PROXY_DING_OA}/ddAttachment/uploadFile`,
        formData
      );
      return data;
    },
    async uploadFile(file) {
      this.$emit("update:uploadLoading", true);

      // 单选时清空列表
      if (!this.multiple && this.fileList.length > 0) {
        this.fileList = [];
        this.dingFileList = [];
      }

      let dingFileData = null;
      if (this.isUploadDing) {
        try {
          dingFileData = this.ddFileUploadFnc
            ? await this.ddFileUploadFnc(file.file)
            : await this.uploadFileToDingDing(file.file);
        } catch (error) {
          console.log("dingFileDataError", error);
        }
      }

      // 上传钉盘失败时，不上传oss
      if (this.isUploadDing && !dingFileData) {
        this.$message.error("上传失败");
        this.$emit("update:uploadLoading", false);
        return;
      }

      let fileData = {
        uid: file.file.uid,
        id: "",
        fileUrl: "",
        url: "",
        path: "",
        name: file.file.name,
        status: "uploading",
        progress: 0,
      };

      if (!this.isUploadDing) {
        this.fileList.push(fileData);
      }

      let formData = new FormData();
      formData.append("file", file.file);

      // 传入的fileUploadFnc方法需要返回{id,url,path}
      try {
        const type = getType(this.fileUploadFnc) || ''
        const { data } =
          type && type.indexOf("Function") > -1 
            ? await this.fileUploadFnc(file.file, fileData)
            : this.isUploadAli
            ? await this.aliUpload(file.file, fileData)
            : await this.oaUpload(formData);
        fileData.id = data.id;
        fileData.fileUrl = data.url;
        fileData.path = data.path;
        fileData.status = "done";
        fileData.data = data;
        Object.assign(fileData, data);

        // 如果是上传到钉盘，要同时插入数组保证下标一致
        if (this.isUploadDing && dingFileData) {
          this.fileList.push(fileData);
          this.dingFileList.push(dingFileData);
        }

        this.$nextTick(() => {
          this.$emit("uploadSuccess", fileData, dingFileData);
        })
        // this.$emit('update:ddAttachmentList', this.dingFileList);
      } catch (error) {
        this.$message.error("上传失败");
        console.log(error);
        this.fileList.splice(this.fileList.indexOf(fileData), 1);
        this.$emit("uploadError", fileData);
      } finally {
        this.$emit("update:uploadLoading", false);
      }
    },
    limitErrorTips: debounce(function() {
      this.$message.error(`文件数量不能超过${this.limit}个`);
    }, 300),
    fileErrorTips: debounce(function() {
      this.$message.error("文件上传失败");
    }, 300),
    acceptErrorTips: debounce(function() {
      this.$message.error("请上传" + this.accept.join(",") + "格式文件");
    }, 300),
    sizeErrorTips: debounce(function() {
      this.$message.error(`文件大小不能超过${this.size}M`);
    }, 300),
    beforeUpload(file, selectFileList) {
      // 有传入beforeUpload方法时使用传入的方法处理,需要返回Boolean值
      const type = getType(this.beforeUploadFnc) || ''
      if (type && type.indexOf("Function") > -1 ) {
        return this.beforeUploadFnc(file);
      }
      // 没有传入时执行默认校验逻辑
      if (!file) {
        this.fileErrorTips();
        return false;
      }
      // 计算总文件数量，已上传+已选中文件数量
      const fileListLength = this.fileList.length + selectFileList.length;
      // 文件数量校验
      if (this.limit && fileListLength > this.limit) {
        this.limitErrorTips();
        return false;
      }
      // 文件类型校验
      if (this.accept && this.accept.length > 0) {
        const fileName = file.name;
        // 获取最后一个.的位置
        const index = fileName.lastIndexOf(".");
        // 获取后缀
        const ext = fileName.substr(index + 1);
        if (!this.accept.includes(ext.toLowerCase())) {
          this.acceptErrorTips();
          return false;
        }
      }
      // 文件大小校验
      if (this.size && file.size > this.size * 1024 * 1024) {
        this.sizeErrorTips();
        return false;
      }
      return true;
    },
    removeFile(file, idx) {
      this.fileList = this.fileList.filter((item) => item.id !== file.id);
      this.dingFileList = this.dingFileList.filter(
        (item, index) => index !== idx
      );
      this.$emit("removeFile", this.fileList, this.dingFileList);
      // this.$emit('update:dingFileList', this.dingFileList);
    },
    fileDownload(file) {
      this.downloadFnc ? this.downloadFnc(file) : downloadCommonFile(file);
    },
    // 判断文件类型
    judgeFileType(data, typeList = this.previewFileType) {
      const type = data.name
        .slice(data.name.lastIndexOf(".") + 1)
        .toLowerCase();
      return typeList.includes(type);
    },
    // 查看文件
    previewUploadFile(file) {
      if (file.status !== "done") return;

      if (this.previewFnc) {
        this.previewFnc(file);
        return;
      }

      previewCommonFile(file);
    },
  },
};
</script>
<style lang="scss" scoped>
ul,
li {
  padding: 0;
  margin: 0;
  list-style: none;
}

.upload-file-btn {
  .upload-btn {
    padding: 0px;
  }

  .file-list-box {
    .file-list-item {
      height: 22px;
      line-height: 22px;

      &:hover {
        background: #e8fffb;
      }

      & + .file-list-item {
        margin-top: 5px;
      }

      & > i {
        float: left;
        line-height: 25px;
      }
    }

    .file-name {
      width: calc(100% - 128px);
      margin-left: 5px;
      float: left;
      // display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .btn-group {
      float: right;
      color: #00bfbf;
      cursor: pointer;

      .btn {
        & + .btn {
          margin-left: 8px;
        }
      }
    }
  }

  &--dragger {
    .file-list-item:first-child {
      margin-top: 10px;
    }
  }
}
</style>
